import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "select"]
  static values  = { url: String }

  connect() {
    this.dropdownEl = null
    this.selectTarget.style.display = "none"
    this.bound = this.#clickOutside.bind(this)
    document.addEventListener("click", this.bound)
  }

  disconnect() {
    document.removeEventListener("click", this.bound)
    this.dropdownEl?.remove()
  }

  async search() {
    const q = this.inputTarget.value.trim()
    if (q.length < 2) { this.#hide(); return }

    const sep = this.urlValue.includes("?") ? "&" : "?"
    const url = `${this.urlValue}${sep}q=${encodeURIComponent(q)}`
    const resp = await fetch(url)
    if (!resp.ok) return
    const data = await resp.json()

    this.#hide()
    if (!data.length) return

    const rect = this.inputTarget.getBoundingClientRect()
    const dropdown = document.createElement("div")
    dropdown.className = "fixed z-[9999] bg-surface-1 border border-border-subtle rounded-lg shadow-lg max-h-48 overflow-y-auto"
    dropdown.style.top  = `${rect.bottom + window.scrollY}px`
    dropdown.style.left = `${rect.left}px`
    dropdown.style.width = `${rect.width}px`
    data.forEach(item => {
      const el = document.createElement("div")
      el.className = "px-3 py-2 text-sm cursor-pointer hover:bg-surface-2 transition-colors"
      el.dataset.id = item.id
      el.textContent = item.name
      // Ville, code postal, SIRET : distingue les agences d'un même réseau
      if (item.hint) {
        const hint = document.createElement("div")
        hint.className = "text-xs text-text-muted truncate"
        hint.textContent = item.hint
        el.appendChild(hint)
      }
      el.addEventListener("click", () => this.#pick(String(item.id), item.name))
      dropdown.appendChild(el)
    })

    document.body.appendChild(dropdown)
    this.dropdownEl = dropdown
  }

  #pick(id, name) {
    this.inputTarget.value = name
    let opt = this.selectTarget.querySelector(`option[value="${id}"]`)
    if (!opt) {
      opt = new Option(name, id)
      this.selectTarget.add(opt)
    }
    this.selectTarget.value = id
    this.#hide()
    this.dispatch("selected", { detail: { id, name } })
  }

  #hide() {
    this.dropdownEl?.remove()
    this.dropdownEl = null
  }

  #clickOutside(event) {
    if (!this.element.contains(event.target) && !this.dropdownEl?.contains(event.target)) {
      this.#hide()
    }
  }
}
